import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import ButtonWithLoading from "components/ButtonWithLoading";
import { useTranslation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
  isOpen: boolean;
  loading: boolean;
  onClose: () => void;
  onRemove: () => void;
}

export function RemoveSecretModal(props: Props) {
  const { t } = useTranslation("gateway");
  const { isOpen, loading, onClose, onRemove } = props;

  return (
    <Dialog open={isOpen}>
      <IconButton
        size="small"
        onClick={onClose}
        style={{ position: "absolute", top: "0.7rem", right: "0.7rem" }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <DialogTitle>{t("gatewaySecret.removeModal.title")}</DialogTitle>
      <DialogContent style={{ marginBottom: 20 }}>
        <Typography variant="body2" style={{ fontSize: 14 }}>
          {t("gatewaySecret.removeModal.body")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          {t("common:cancel")}
        </Button>
        <ButtonWithLoading
          disableElevation
          variant="contained"
          size="small"
          loading={loading}
          onClick={onRemove}
        >
          {t("gatewaySecret.removeModal.removeBtn")}
        </ButtonWithLoading>
      </DialogActions>
    </Dialog>
  );
}
